import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPermissionSlug.ts
var t = () => e("permissionSlug");
//#endregion
export { t as useTrPermissionSlug };
